import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { HttpService } from 'src/app/core';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-document-delete-confirm-dialog',
  templateUrl: './delete-confirm-dialog.component.html',
  styleUrls: ['./delete-confirm-dialog.component.scss']
})

export class DeleteConfirmDialogComponent implements OnInit {

  fileId: any;
  project: any;
  fileType: string;

  constructor(
    private dialogRef: MatDialogRef<any>,
    private httpService: HttpService,
    private toastr: ToastrService,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) { }

  ngOnInit(): void {
    this.fileId = this.data.fileId;
    this.project = this.data.project;
    this.fileType = this.data.fileType;
  }

  cancel() {
    this.dialogRef.close();
  }

  confirm() {
    if (this.fileType === 'terms') {
      this.deleteTermsFiles(this.fileId);
    } else if (this.fileType === 'project') {
      this.deleteDocumentFiles(this.fileId);
    } else if (this.fileType === 'eoi') {
      this.deleteEoiFile();
    }
  }

  deleteTermsFiles(fileId) {

    this.httpService.deleteTermsFiles(this.project.id, fileId).subscribe((res: any) => {

      if (res.code === 1) {
        this.dialogRef.close({ fileId: this.fileId, fileType: this.fileType });
        this.toastr.success('The file has been removed.');
      } else if (res.code === 0) {
        this.toastr.error('Failed to remove this file');
      }
    });
  }

  deleteDocumentFiles(fileId) {
    console.log(fileId);
    this.httpService.deleteDocumentFiles(this.project.id, fileId).subscribe((res: any) => {
      console.log(res);
      if (res.code === 1) {
        this.dialogRef.close({ fileId: this.fileId, fileType: this.fileType });
        this.toastr.success('The file has been removed.');
      } else if (res.code === 0) {
        this.toastr.error('Failed to remove this file');
      }
    });
  }

  deleteEoiFile() {
    this.httpService.deleteEoiFile(this.project.id).subscribe((res: any) => {
      if (res.code === 1) {
        this.dialogRef.close({ fileId: this.fileId, fileType: this.fileType });
        this.toastr.success('The file has been removed.');
      } else if (res.code === 0) {
        this.toastr.error('Failed to remove this file');
      }
    })

  }
}
